import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom';
import CommonPopup from '../../Components/ClientDashboard/ClientSurveys/CommonPopup'
import HideText from '../../Components/ClientDashboard/Clientcommon/HidePageText';

const SURVEY_LINK_CHECK_URL = 'https://api.skepper.in/check_link_and_get_id.php';

const CommonPopupPage = () => {
  const { surveyId } = useParams();
  const [surveyLinkStatus, setSurveyLinkStatus] = useState('checking');

  useEffect(() => {
    const controller = new AbortController();

    const validateSurveyLink = async () => {
      if (!surveyId) {
        setSurveyLinkStatus('invalid');
        return;
      }

      try {
        const response = await fetch(SURVEY_LINK_CHECK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ link: surveyId }),
          signal: controller.signal,
        });
        const data = await response.json();

        setSurveyLinkStatus(data.success ? 'valid' : 'invalid');
      } catch (error) {
        if (error.name !== 'AbortError') {
          setSurveyLinkStatus('invalid');
        }
      }
    };

    validateSurveyLink();

    return () => controller.abort();
  }, [surveyId]);

  if (surveyLinkStatus === 'checking') {
    return null;
  }

  if (surveyLinkStatus === 'invalid') {
    return <Navigate to="/404" replace />;
  }

  return (
    <div id='common_mobile'>
          <CommonPopup/>
          <HideText/>

    </div>
  )
}

export default CommonPopupPage
